import type { Brand } from '~/types/user';

import { Icon } from '~/components';

import { nameCellStyle } from './brandCell.css';

type Props = {
  brand: Brand;
};

export const BrandNameCell = ({ brand }: Props) => {
  return (
    <div className={nameCellStyle}>
      <span>{brand.companyName}</span>

      {brand.isFavorite && <Icon name="StarFill" size={20} />}
    </div>
  );
};
